
export default {
  props: ["item", "size","subtitle","noSubtitle","extraClass","popup","stores","extraClassIcon"],
  name: "availability",
  data() {
    return {
    };
  },
};
